import React, { useEffect, useState } from "react";
import { Table, Dropdown, Menu, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchRequest,
  downloadRequest,
  singleUpdateRequest,
  singleUpdateResponse,
  updateFilters
} from "../../../store/actions/alertsShipment";
import { Box } from "@mui/material";
import { dateFormatWithAt, dateFormatWithSubject } from "../../../global/utility/dateFormat";
import ToastNotification from "../../../global/components/ToastNotification";
import dayjs from "dayjs";
import {
  DropdownFilterWithCheckboxAndInitialValue,
  DropdownFilterWithSearchAndCheckbox,
  DropdownFilterWithDateRangePicker,
} from "../../../components/DropdownFilter";
import {setShipmentStatusGlobal} from "../../../store/actions/shipment";
import AlertsShipmentDetails from "./AlertsShipmentDetails";
import AlertsBulkDetails from "./AlertsBulkDetails";
// import AlertsDetails from "./AlertsDetails";
let intialValue = [
  { text: "New", value: true },
  { text: "Acknowledged", value: false },
  { text: "Resolved", value: false },
  { text: "Auto Resolved", value: false },
];
const AlertsShipmentList = ({ shipmentid, setActiveTab }) => {
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  // Redux state selectors
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.alertsShipment.isLoading);
  const alertCounts = useSelector((state) => state.alertsShipment.alertCounts);
  const filters = useSelector((state) => state.alertsShipment.filters);
  const alerts = useSelector((state) => state.alertsShipment.data.alerts);
  const statuses = useSelector((state) => state.alertsShipment.data.statuses);
  const InitialStatus = useSelector(
    (state) => state.alertsShipment.data.status
  );
  const levels = useSelector((state) => state.alertsShipment.data.level);
  const notification = useSelector(
    (state) => state.alertsShipment.notification
  );
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isbulkPopupVisible, setIsBulkPopupVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); // State to manage selected items
  const shipmentStatus = useSelector(state=>state.shipment.shipmentStatus);
  const handleCheckboxChange = (checked, recordId) => {
    if (checked) {
      setSelectedItems((prevItems) => [...prevItems, { id: recordId }]);
    } else {
      setSelectedItems((prevItems) =>
        prevItems.filter((item) => item.id !== recordId)
      );
    }
  };

  const handleTableChange = (pagination) => {
    if (
      Object.hasOwn(pagination, "current") &&
      filters.pagenumber !== pagination.current - 1
    ) {
      dispatch(
        fetchRequest({ ...filters, pagenumber: pagination.current - 1 })
      );
    }
  };

  const handleStatusFilterChange = (val) => {
    const filterArr = Object.entries(val.filters);

    if (filterArr.length === 0) {
      return;
    }

    const filterValue = filterArr.map((filter) => ({
      text: filter[0],
      value: filter[1],
    }));
    dispatch(
      fetchRequest({
        ...filters,
        status: filterValue,
      })
    );
  };

  const handleStatusFilterReset = () => {
    dispatch(
      fetchRequest({
        ...filters,
        status: InitialStatus,
      })
    );
  };

  const handleLevelFilterChange = (val) => {
    let order = val.isAsc ? "asc" : "desc";
    let field = "severity";
    dispatch(
      fetchRequest({
        ...filters,
        sort: [{ field, order }],
        level: val.filters || {},
      })
    );
  };

  const handleLevelFilterReset = (val) => {
    let order = val.isAsc ? "asc" : "desc";
    let field = "severity";
    dispatch(
      fetchRequest({
        ...filters,
        sort: [{ field, order }],
        level: "",
      })
    );
  };

  const handleLastUpdatedFilterChange = (val) => {
    let startDate = "";
    let endDate = "";

    if (val?.filters?.text?.length > 0) {
      const [start, end] = val.filters.text;
      startDate = dayjs(start).format("YYYY-MM-DD");
      endDate = dayjs(end).format("YYYY-MM-DD");
    }

    const order = val.isAsc ? "asc" : "desc";
    dispatch(
      fetchRequest({
        ...filters,
        sort: [{ field: "lastupdated", order }],
        lastUpdated:
          val?.filters?.text?.length > 0
            ? [dayjs(startDate), dayjs(endDate)]
            : "",
      })
    );
  };

  const handleLastUpdatedFilterReset = () => {
    dispatch(fetchRequest({ ...filters, lastUpdated: "" }));
  };

  const handleSubjectSearch = (val) => {
    let order = val.isAsc ? "asc" : "desc";
    let subjectFilter = "";
    if (val.filteredResult && val.filteredResult.length > 0) {
      subjectFilter = val.filteredResult;
    } else if (val.filters?.text) {
      subjectFilter = val.filters.text;
    }
    dispatch(
      fetchRequest({
        ...filters,
        sort: [{ field: "name", order }],
        subject: subjectFilter,
      })
    );
  };

  const handleSubjectSearchReset = () => {
    dispatch(
      fetchRequest({
        ...filters,
        subject: "",
      })
    );
  };

  const handleDownload = () => {
    try {
      dispatch(downloadRequest({ page_no: 0, shipmentid: shipmentid }));
      setNotificationProps({
        type: "success",
        message: "Export",
        description: "Export completed successfully.",
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } catch (error) {
      setNotificationProps({
        type: "error",
        message: "Export",
        description: error.message || "Unable to serialize unrecognized input.",
        duration: 5,
        style: { backgroundColor: "#FFECE0", color: "black" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    }
  };

  const editAlerts = (record) => {
    if (record) {
      dispatch(
        singleUpdateRequest({
          current: record,
          fields: {
            status: record?.status,
            comment: record?.lastComment,
          },
        })
      );
      setIsPopupVisible(true);
    }
  };
  useEffect(() => {
    const shipmentStatusModified = shipmentStatus==='Error'? 'Critical': shipmentStatus;
    const level = {};
    level[shipmentStatusModified]=true;
    const filtersModified = {...filters,level};
    filtersModified[shipmentid]=shipmentid;
    dispatch(
      fetchRequest({
        ...filtersModified,
        status: intialValue,
        shipmentid: shipmentid,
        // deviceid: deviceid,
      })
    );
    if (notification.isActive) {
      dispatch(
        singleUpdateResponse({
          isActive: false,
          message: "",
          description: "",
        })
      );
    }
  }, [
    dispatch, notification, shipmentStatus, shipmentid
  ]);

  useEffect(()=>{
    return ()=>{
      dispatch(setShipmentStatusGlobal(null));
      updateFilters({level:''})
    }
  },[])

  const bulkeditAlerts = (record) => {
    if (record) {
      setIsBulkPopupVisible(true);
    }
  };
  function capitalizeFirstLetter(name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  const tableData = alerts.map((val) => {
    const batteryCriticalValue = val?.condition?.startsWith(
      "$[?(@.eventMsg.fields.battery <"
    )
      ? val.condition
          .replaceAll("$[?(@.eventMsg.fields.battery <", "")
          .replaceAll(")]", "")
          .trim()
      : "N/A";

    let acknowledged = null;
    if (!val?.state) {
      if (val.isacknowledged === false && val.iscleared === false) {
        acknowledged = "New";
      } else if (val.isacknowledged === true && val.iscleared === false) {
        acknowledged = "Acknowledge";
      } else if (val.isacknowledged === false && val.iscleared === true) {
        acknowledged = "Resolved";
      }
    } else {
      acknowledged = "Auto Resolved";
    }
    const rawDeviceId =
      val?.metadata?.devicename?.split(": ")?.[1] ||
      val?.description?.split(": ")?.[1]?.replace(/\.$/, "") ||
      "N/A";
    return {
      key: val?.id,
      billingaccountid: val?.billingaccountid,
      value: val,
      lastupdated: val.lastupdated,
      shipmentname: val.name,
      batteryLevel: `Battery Level Below ${batteryCriticalValue}%`,
      batteryValue: val?.metadata?.battery,
      batteryCriticalValue,
      siteId: val?.metadata?.siteId,
      locationName:
        val?.metadata?.locationName || "device_bulkupdate_dummy_tag",
      orgId: val?.metadata?.orgId,
      organization:
        val?.metadata?.organizationName || "device_bulkupdate_dummy_tag",
      isacknowledged: acknowledged,
      condition: capitalizeFirstLetter(val.severity),
      lastComment:
        val?.metadata?.audit?.[val.metadata.audit.length - 1]?.comment,
      name:
        val.condition === "$[?(@.eventMsg.fields.battery < 10)]"
          ? "Battery Level Below 10%"
          : "Battery Level Below 20%",
      device:
        rawDeviceId !== "N/A"
          ? `Gateway: ${rawDeviceId.replace(/\.$/, "")}`
          : "N/A",
      deviceid: val?.deviceid,
      action: (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item>
                {user?.role?.permissions?.alarms?.view && (
                  <div
                    role="button"
                    className="dropdown-item"
                    onClick={() =>
                      editAlerts({
                        id: val?.id,
                        record: val,
                        setActiveTab: setActiveTab,
                        billingaccountid: val?.billingaccountid,
                        name: val?.name,
                        msg: `Battery Level Below ${batteryCriticalValue}%`,
                        batteryCriticalValue: val.condition.includes("<")
                          ? "Minimum"
                          : "Maximum",
                        criticalValue: val.name.split(/<|>/)[1]?.replace(/[^0-9.]/g, ""),
                        batteryValue: val?.metadata["eventMsg"]?.fields,
                        siteId: val?.metadata?.siteId,
                        locationName: val?.metadata?.locationName,
                        orgId: val?.metadata?.orgId,
                        organization: val?.metadata?.organizationName,
                        device: val?.metadata?.devicename,
                        level: val.severity,
                        status: acknowledged,
                        lastupdated: val?.lastupdated,
                        createdon: val?.createdon,
                        shipment: val?.metadata?.shipmentname,
                        alertgroup: val?.metadata["contact-group"],

                        lastComment:
                          val?.metadata?.audit?.[val.metadata.audit.length - 1]
                            ?.comment,
                      })
                    }
                  >
                    View Alert
                  </div>
                )}
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <button
            className="btn btn-link text-secondary"
            onClick={(e) => e.preventDefault()}
          >
            <i className="bi-three-dots-vertical fs-6" />
          </button>
        </Dropdown>
      ),
    };
  });
  const updatedStatus = (val) => {
    let acknowledged = null;
    if (!val?.state) {
      if (val.isacknowledged === false && val.iscleared === false) {
        acknowledged = "New";
      } else if (val.isacknowledged === true && val.iscleared === false) {
        acknowledged = "Acknowledge";
      } else if (val.isacknowledged === false && val.iscleared === true) {
        acknowledged = "Resolved";
      }
    } else {
      acknowledged = "Auto Resolved";
    }
    return acknowledged;
  };
  const columns = [
    {
      title: (
        <DropdownFilterWithCheckboxAndInitialValue
          text="Status"
          onApply={handleStatusFilterChange}
          onReset={handleStatusFilterReset}
          menuItems={statuses}
        />
      ),
      dataIndex: "isacknowledged",
      key: "isacknowledged",
      render: (text, record) => (
        <div className="d-flex flex-row justify-content-start align-items-center">
          {text !== "Auto Resolved" && (
            <Checkbox
              key={record.id}
              checked={selectedItems.some((item) => item.id === record.key)}
              defaultChecked={false}
              className="me-3"
              onChange={(e) =>
                handleCheckboxChange(e.target.checked, record.key)
              }
            />
          )}
          <Box style={{ marginLeft: text === "Auto Resolved" && 30 }}>
            {text}
          </Box>
        </div>
      ),
    },
    {
      title: (
        <DropdownFilterWithCheckboxAndInitialValue
          text="Severity"
          //isSortable={true}
          onApply={handleLevelFilterChange}
          onReset={handleLevelFilterReset}
          menuItems={levels.map((level) => ({
            text: level.label,
            value: level.value,
          }))}
        />
      ),
      dataIndex: "condition",
      key: "condition",
      className: "alert-severity",
      render: (text) => (
        <Box
          className={`${
            text === "Warning" || text?.toLowerCase() === "major" ||
            text === "Error" ||
            (text === "Critical" && "font-face-vzw")
          } ${
            text === "Error" || text === "Critical"
              ? "alarm-condition-error"
              : text === "Warning" || text?.toLowerCase() === "major"
              ? "alarm-condition"
              : ""
          }`}
          style={{
            display: "inline-block",
            padding: "1px 5px",
            borderRadius: "2px",
            textAlign: "center",
          }}
        >
        {text === "Error" || text === "Critical"
            ? "Critical"
            : text === "Warning" || text?.toLowerCase() === "major"
            ? "Warning"
            : text?.toLowerCase() === "minor"? "Notification":text}
        </Box>
      ),
    },
    {
      title: (
        <DropdownFilterWithSearchAndCheckbox
          text="Subject"
          isSortable={true}
          onApply={handleSubjectSearch}
          onReset={handleSubjectSearchReset}
        />
      ),
      dataIndex: "shipmentname",
      key: "shipmentname",
      render: (text, record) => {
        let subject = record?.value?.name || "";

        if (subject && subject?.match(/\d{4}-\d{2}-\d{2}/gi)) {
          const [text, dateString] = subject.split(" at");
          subject = `${text} at ${dateFormatWithSubject(dateString?.trim())}`;
        }
        return (
          <div>
            <div>
              <div
                role="button"
                onClick={() =>
                  editAlerts({
                    id: record?.value?.id,
                    record: record?.value,
                    setActiveTab: setActiveTab,
                    billingaccountid: record?.value?.billingaccountid,
                    name: subject,
                    msg: `Battery Level Below 10%`,
                    batteryCriticalValue: record.value?.condition.includes("<")
                      ? "Minimum"
                      : "Maximum",
                    criticalValue: record.value?.name.split(/<|>/)[1]?.replace(/[^0-9.]/g, ""),
                    batteryValue:
                      record?.value?.metadata["eventMsg"]?.fields,
                    siteId: record?.value?.metadata?.siteId,
                    locationName: record?.value?.metadata?.locationName,
                    orgId: record?.value?.metadata?.orgId,
                    organization: record?.value?.metadata?.organizationName,
                    device: record?.value?.metadata?.devicename,
                    level: record.value?.severity,
                    status: updatedStatus(record.value),
                    lastupdated: record?.value?.lastupdated,
                    createdon: record?.value?.createdon,
                    shipment: record?.value?.metadata?.shipmentname,
                    alertgroup: record?.value?.metadata["contact-group"],

                    lastComment:
                      record?.value?.metadata?.audit?.[
                        record.value?.metadata.audit.length - 1
                      ]?.comment,
                  })
                }
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                {subject}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <DropdownFilterWithDateRangePicker
        accountId={user?.accountId}
          text="Last updated"
          isSortable={true}
          onApply={handleLastUpdatedFilterChange}
          onReset={handleLastUpdatedFilterReset}
        />
      ),
      dataIndex: "lastupdated",
      className: "alert-lastupdated",
      render: (text) => <span>{dateFormatWithAt(text)}</span>,
      key: "lastupdated",
    },
    {
      title: (
        <Dropdown
          overlay={
            <Menu>
              {/* Additional filter removed from the dropdown */}
              <Menu.Item>
                <div style={{ minWidth: 170 }}>
                  <div>
                    <span className="font-face-vzw fw-bold">Actions</span>
                    {user?.role?.permissions?.alarms?.edit && (
                      <div
                        className="mt-2 cursor-pointer"
                        onClick={() =>
                          selectedItems.length > 0
                            ? bulkeditAlerts({
                                subject: `${filters.subject}`,
                                level: `${filters.level}`,
                              })
                            : undefined
                        }
                      >
                        Bulk edit
                      </div>
                    )}
                    {user?.role?.permissions?.alarms?.download && (
                      <div
                        className="mt-2 cursor-pointer"
                        onClick={handleDownload}
                      >
                        Export
                      </div>
                    )}
                  </div>
                </div>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <button
            className="btn btn-link text-secondary"
            onClick={(e) => e.preventDefault()}
          >
            <i className="bi-three-dots-vertical fs-6" />
          </button>
        </Dropdown>
      ),
      dataIndex: "action",
    },
  ];
  const handlePageSizeChange = (page, pageSize) => {
    dispatch(fetchRequest({ ...filters, limitnumber: pageSize }));
  };

  return (
    <div
      style={{
        marginTop: "20px",
        backgroundColor: "#fff",
        borderRadius: "12px",
      }}
    >
      {notification.isActive && (
        <ToastNotification
          type={notification.type}
          message={notification.message}
          description={notification.description}
          duration={1}
          style={notification.style}
        />
      )}
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}

      <div>
        <AlertsShipmentDetails
          visible={isPopupVisible}
          closePopup={() => setIsPopupVisible(false)}
          setActiveTab={setActiveTab}
        />
        <AlertsBulkDetails
          visible={isbulkPopupVisible}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          closePopup={() => setIsBulkPopupVisible(false)}
        />
      </div>

      <Table
        rowKey="key"
        loading={isLoading}
        columns={columns}
        dataSource={tableData}
        onChange={handleTableChange}
        style={{
          width: "100%",
          minWidth: "1200px",
          overflowX: "auto",
        }}
        // scroll={{ x: "max-content" }}
        pagination={
          alertCounts.total > 10 && {
            current: filters.pagenumber + 1,
            pageSize: filters.limitnumber,
            total: alertCounts.total,
            showTotal: (total, range) =>
              `Showing ${range[0]}-${range[1]} of ${total}`,
            position: ["bottomRight"],
            prevIcon: ["Prev"],
            nextIcon: ["Next"],
            onChange: (page, pageSize) => handlePageSizeChange(page, pageSize),
            showSizeChanger: true,
          }
        }
      />
    </div>
  );
};

export default AlertsShipmentList;
